import { intersection } from 'lodash';

/**
 * The calendar tag filters that should actually be APPLIED, given the filters
 * in the URL and what the vendor's tags are right now.
 *
 * The URL is not trustworthy on its own: a bookmark outlives a tag being
 * deleted or retired, and outlives the JOB_TAGS module being switched off.
 * Applied as-is, an id that no job can carry hides every job on the calendar
 * — and the only control that could clear it (`JobTagFilterSelect`) renders
 * nothing when the module is off, and can't draw a tag it no longer knows.
 *
 * So a filter is honoured only for a tag the control can show: with the
 * module off there are none, and once the vendor's tags have loaded anything
 * not among the enabled ones is dropped. Until they HAVE loaded the URL is
 * taken at its word — pruning against an empty, still-loading list would
 * throw away a perfectly good bookmark.
 *
 * Pure and separate from the hook so the rule can be tested directly.
 * @param params
 * @param params.tagFilters the tag ids from the calendar's URL state.
 * @param params.enabledTagIds the vendor's enabled tag ids.
 * @param params.jobTagsEnabled whether the JOB_TAGS module is on.
 * @param params.tagsLoaded whether the vendor's tags have been fetched.
 * @returns the tag ids to filter jobs by; empty means no filter.
 */
export function resolveTagFilters(params: {
  tagFilters: readonly string[];
  enabledTagIds: readonly string[];
  jobTagsEnabled: boolean;
  tagsLoaded: boolean;
}): string[] {
  if (!params.jobTagsEnabled) return [];
  if (!params.tagsLoaded) return [...params.tagFilters];
  return intersection(params.tagFilters, params.enabledTagIds);
}
